// Cliente para el endpoint público de auto-registro (/api/auth/register).
// No lleva token: la protección es el secreto del magic link + el dominio,
// validados en el backend.
const URI = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export async function registerUser(email, password, secret) {
  const response = await fetch(`${URI}api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, secret }),
  });

  let body = null;
  try {
    body = await response.json();
  } catch (_) {
    // no JSON body
  }

  if (!response.ok) {
    const error = new Error(body?.message || `HTTP error ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return body;
}
